import { InjectedFormProps, DecoratedFormProps, reduxForm, SubmissionError, FieldArray } from 'redux-form';
import { FormError } from 'src/components/redux-form/FormError';
import React, { useEffect, useState } from 'react';
import { maxLength, Validators, required } from 'src/components/redux-form/utils/validators';
import classNames from 'classnames';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { FieldDate } from 'src/components/redux-form/fields/FieldDate';
import { FieldDropdown } from 'src/components/redux-form/fields/FieldDropdown';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/orders-form.module.scss';
import { faSave, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { asyncPersistOrder, getOrders } from 'src/store/actions/order-actions';
import { Dispatch } from 'redux';
import { toast } from 'react-toastify';
import { DropZoneField } from 'src/components/DropZoneField';
import Loader from '../../../../../components/Loader';
import ArrayValues from './RenderFieldArray';
import { useDispatch, useSelector } from 'react-redux';
import { miniLoaderForSelector } from 'src/store/selectors/orders-selectors';
import { loaderSelector } from 'src/store/selectors/students-selectors';
import { Button, Modal } from 'react-bootstrap';
import { changeToZeroMomentDate } from '../../../../../helpers/timeHelpers';

export interface OrderFormData {
    id: string | number;
    name: string;
    location: string;
    orders: any;

    studentDropDown: SelectObject | undefined;
    orderDocName: string | null;
    orderDocMimeType: string | null;
    orderCaseTypeDropDown: SelectObject | undefined;
    orderTypeDropDown: SelectObject | undefined;
    serviceTypeProviderDropDown: SelectObject | undefined;
    caseNumber: string;
    maximumAvailableHours: number;
    orderDate: string;
    caseNumberValidityFrom: string;
    caseNumberValidityTo: string;
    serviceTypeDropDown: SelectObject | undefined;
    statusDropDown: SelectObject | undefined;
    orderReferralSourceDropDown: SelectObject | undefined;
    orderSubtypeDropDown: SelectObject | undefined;
    authorizationDateRequest: string;
    authorizationDate: string;
    authorizationSourceDropDown: SelectObject | undefined;
    note: string | null;
    allocatedPeriodDropDown?: SelectObject | undefined;
    allocatedHours?: string;
    allocatedMoney?: string;
    orderExpiration?: string;
}

interface OrderFormProps {
    files: any;
    studentsValues: SelectObject[];
    valueType?: SelectObject;
    formData: OrderFormData;
    valuesOrderSubtype: SelectObject[];
    orderCaseTypeValues: SelectObject[];
    orderReferralSourceValues: SelectObject[];
    serviceTypesOrderValues: SelectObject[];

    valuesOrderStatus: SelectObject[];
    AuthorizationSources: SelectObject[];
    orderTypeValue: string | number;
    serviceTypeProviderValue: string | number;
    statusItemValue: string | number;
    status?: string | number;
    referralSource?: number | string;
    OrderTypes: SelectObject[];
    ServiceTypeProviders: SelectObject[];

    orderDoc: any;
    setOrderDoc: (it: any) => void;
    removeOrderDoc: (it: any) => void;

    setFiles: (it: []) => void;
    removeFile: (it: any) => void;

    dataSaveModal: any;
    setSaveModal: any;
    isUniqueName: any;
    handleCheck: any;
    isDouble: any;
    resetDouble: any;
}

type InjectedProps = InjectedFormProps<OrderFormData, OrderFormProps>;

const validators: Validators<OrderFormData> = {
    name: [required({ message: 'Name is required.' }), maxLength({ max: 255 })],
    location: [required({ message: 'Location is required.' }), maxLength({ max: 255 })],
    orderCaseTypeDropDown: [required({ message: 'Type is required.' }), maxLength({ max: 255 })],
    caseNumberValidityFrom: [required({ message: 'Case Number Validity From is required.' }), maxLength({ max: 255 })],
    caseNumberValidityTo: [required({ message: 'Case Number Validity To is required.' }), maxLength({ max: 255 })],
    allocatedPeriodDropDown: [required({ message: 'Allocated Hours per is required.' }), maxLength({ max: 255 })],
    allocatedHours: [required({ message: 'Number of allocated hours is required.' }), maxLength({ max: 255 })],
    maximumAvailableHours: [required({ message: 'Maximum Available Hours is required.' }), maxLength({ max: 255 })],
    allocatedMoney: [maxLength({ max: 255 })],
    studentDropDown: [maxLength({ max: 255 })],

    caseNumber: [required({ message: 'Case Number is required.' }), maxLength({ max: 255 })],
    orderSubtypeDropDown: [maxLength({ max: 255 })],
    orderDate: [maxLength({ max: 255 })],
    authorizationDateRequest: [maxLength({ max: 255 })],
    authorizationDate: [maxLength({ max: 255 })],
    authorizationSourceDropDown: [maxLength({ max: 255 })],
    orderReferralSourceDropDown: [maxLength({ max: 255 })],
    serviceTypeDropDown: [required({ message: 'Service Type is required.' }), maxLength({ max: 255 })],
    serviceTypeProviderDropDown: [required({ message: 'Service Type Provider is required.' }), maxLength({ max: 255 })],
    statusDropDown: [required({ message: 'Status is required.' }), maxLength({ max: 255 })],
};
const OrderForm: React.FunctionComponent<InjectedProps & OrderFormProps> = ({
    handleSubmit,
    error,
    dirty,
    valid,
    files,
    setFiles,
    valueType,
    OrderTypes,
    ServiceTypeProviders,
    removeFile,
    studentsValues,
    orderCaseTypeValues,
    orderDoc,
    setOrderDoc,
    serviceTypesOrderValues,
    valuesOrderSubtype,
    handleCheck,
    isUniqueName,
    resetDouble,

    orderReferralSourceValues,
    referralSource,
    valuesOrderStatus,
    AuthorizationSources,
    submitting,
    status,
    statusItemValue,
    initialValues,
    formData,
    setSaveModal,
    dataSaveModal,
    isDouble,
}: InjectedProps & OrderFormProps) => {
    const isNew = !initialValues || !initialValues.id;
    const statusInit = initialValues?.statusDropDown?.value ? +initialValues.statusDropDown.value : 0;
    const isDraft = statusItemValue === 3 ? true : false;
    const [dataModal, setModal] = useState(false);
    //const [dataSaveModal, setSaveModal] = useState(false);
    const miniLoaderFor = useSelector(miniLoaderForSelector);

    const orderDocFiles = [];
    if (orderDoc) {
        const orderDocFile = {
            attach: orderDoc,
            mimeType: initialValues.orderDocMimeType,
            name: initialValues.orderDocName,
        };

        orderDocFiles.push(orderDocFile);
    }

    const loaderForSelectorStudent = useSelector(loaderSelector);
    const handleSub = (event: any) => {
        if (statusItemValue !== status && statusItemValue === 2) {
            event.preventDefault();
            setModal(true);
        }
    };

    const simulateClick = (e: any) => {
        if (isDouble == 'no') {
            setTimeout(() => {
                e?.click();
                resetDouble();
            }, 500);
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit} className={classNames(styles.form)}>
                <FormError error={error} />
                <FieldInput
                    name="id"
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />

                <FieldDropdown
                    name="orderCaseTypeDropDown"
                    data={orderCaseTypeValues}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.orderCaseTypeDropDown : undefined}
                    wrapperConfig={{
                        label: 'Type *:',
                    }}
                />
                <div className={'position-relative'}>
                    {loaderForSelectorStudent ? <Loader /> : null}
                    <FieldDropdown
                        name="studentDropDown"
                        data={studentsValues}
                        disabled={!isNew && statusItemValue !== 3 && statusInit !== 3}
                        textField={'label'}
                        valueField={'value'}
                        validate={!isDraft ? validators.studentDropDown : undefined}
                        wrapperConfig={{
                            label: 'Student Full Name:',
                        }}
                    />
                </div>
                <FieldInput
                    name="caseNumber"
                    type="text"
                    validate={
                        !isDraft
                            ? valueType && +valueType.value === +2
                                ? undefined
                                : validators.caseNumber
                            : undefined
                    }
                    wrapperConfig={{
                        label: `Case Number ${valueType && +valueType.value === +2 ? ':' : '*:'}`,
                    }}
                />
                <FieldDate
                    name="orderDate"
                    type="text"
                    date={true}
                    wrapperConfig={{
                        label: 'Order Date:',
                    }}
                />

                <FieldDropdown
                    name="orderSubtypeDropDown"
                    data={valuesOrderSubtype}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.orderSubtypeDropDown : undefined}
                    wrapperConfig={{
                        label: 'Order Subtype:',
                    }}
                />
                <FieldDate
                    name="authorizationDateRequest"
                    type="text"
                    date={true}
                    wrapperConfig={{
                        label: 'Date Authorization Was Requested:',
                    }}
                />
                <FieldDate
                    name="authorizationDate"
                    type="text"
                    date={true}
                    wrapperConfig={{
                        label: 'Authorization Date:',
                    }}
                />
                <FieldDropdown
                    name="authorizationSourceDropDown"
                    data={AuthorizationSources}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.authorizationSourceDropDown : undefined}
                    wrapperConfig={{
                        label: 'Authorization Source:',
                    }}
                />
                <FieldDropdown
                    name="statusDropDown"
                    data={valuesOrderStatus}
                    textField={'label'}
                    valueField={'value'}
                    validate={!isDraft ? validators.statusDropDown : undefined}
                    wrapperConfig={{
                        label: 'Order Status *:',
                    }}
                />
                <div style={{ display: 'none' }}>
                    <FieldDropdown
                        name="orderReferralSourceDropDown"
                        data={orderReferralSourceValues}
                        textField={'label'}
                        valueField={'value'}
                        validate={!isDraft ? validators.orderReferralSourceDropDown : undefined}
                        wrapperConfig={{
                            label: 'Referral:',
                        }}
                    />
                </div>
                <div className={'position-relative'}>
                    {miniLoaderFor['FILE'] ? <Loader noFull={true} /> : null}
                    <div>
                        <div>The Order:</div>
                        <DropZoneField single={true} files={orderDocFiles} setFiles={setOrderDoc} />
                    </div>
                    <div style={{ marginBottom: '10px' }}>Other Supporting Documents:</div>
                    <DropZoneField
                        files={files}
                        setFiles={setFiles}
                        removeFile={(id: string | number) => removeFile(id)}
                    />
                </div>
                <FieldArray
                    name="orders"
                    formData={formData}
                    serviceTypesOrderValues={serviceTypesOrderValues}
                    OrderTypes={OrderTypes}
                    ServiceTypeProviders={ServiceTypeProviders}
                    isDraft={isDraft}
                    validators={validators}
                    statusItemValue={statusItemValue}
                    statusInit={statusInit}
                    isNew={isNew}
                    component={ArrayValues}
                />

                <div className={classNames(styles.actions)}>
                    {isDouble === 'no' ? (
                        <button
                            type="submit"
                            onClick={(event) => handleSub(event)}
                            className={classNames('btn', 'btn-success', 'mr-3')}
                            disabled={!dirty || submitting}
                            ref={simulateClick}
                        >
                            <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                        </button>
                    ) : (
                        <button
                            type="button"
                            onClick={handleSubmit(handleCheck)}
                            className={classNames('btn', 'btn-success', 'mr-3')}
                            disabled={!dirty || submitting}
                        >
                            <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                        </button>
                    )}

                    <Link
                        className={classNames('btn', 'btn-danger')}
                        to={Router.generate(routes.ORDERS_LIST, { status: '' })}
                    >
                        <FontAwesomeIcon icon={faBan} /> Cancel
                    </Link>
                </div>
            </form>
            <Modal
                show={dataModal}
                onHide={() => {
                    setModal(false);
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Cases and Sessions can't be created or updated in inactive orders. Are you sure?{' '}
                </Modal.Body>
                <Modal.Footer>
                    <form onSubmit={handleSubmit}>
                        <Button
                            className={'mr-2'}
                            variant="secondary"
                            onClick={() => {
                                setModal(false);
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => {
                                setModal(false);
                            }}
                            variant="danger"
                            type="submit"
                        >
                            Yes
                        </Button>
                    </form>
                </Modal.Footer>
            </Modal>

            <Modal
                show={dataSaveModal}
                onHide={() => {
                    setSaveModal(false);
                    resetDouble();
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Another order with the same order name already exists. Are you sure you want to duplicate it?{' '}
                </Modal.Body>
                <Modal.Footer>
                    <form onSubmit={handleSubmit}>
                        <Button
                            className={'mr-2'}
                            variant="secondary"
                            onClick={() => {
                                setSaveModal(false);
                                resetDouble();
                            }}
                        >
                            Cancel
                        </Button>
                        <button
                            type="submit"
                            onClick={(event) => handleSub(event)}
                            className={classNames('btn', 'btn-success', 'mr-3')}
                            disabled={!dirty || submitting}
                        >
                            <FontAwesomeIcon icon={faSave} /> {isNew ? 'Create' : 'Update'}
                        </button>
                    </form>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default reduxForm<OrderFormData, OrderFormProps>({
    form: 'order-form',
    enableReinitialize: true,
    onSubmit: async (data: OrderFormData, dispatch: Dispatch<any>, props: OrderFormProps) => {
        if (!data.orders || !data.orders.length) {
            toast.error('At least one service form must be filled in');
        }

        // persist one order at a time: the saga uploads the shared files right after the order is
        // created, and firing every request in the same tick made those uploads race each other
        for (const order of data.orders as any[]) {
            const dateFrom = new Date(order.caseNumberValidityTo).getTime();
            const dateTo = new Date(order.caseNumberValidityFrom).getTime();

            if (dateTo < dateFrom) {
                let name: any = [];

                const student_caseNumber: any = [];
                const caseDate: any = [];
                if (data.studentDropDown) {
                    student_caseNumber.push(data.studentDropDown.label);
                }
                if (data.caseNumber) {
                    student_caseNumber.push(data.caseNumber);
                }
                if (student_caseNumber.length) {
                    name.push(student_caseNumber.join('_'));
                }

                if (order.serviceTypeProviderDropDown?.value) {
                    name.push(order.serviceTypeProviderDropDown.label);
                }
                if (order.serviceTypeDropDown?.value) {
                    name.push(order.serviceTypeDropDown.label);
                }
                if (order.caseNumberValidityFrom) {
                    caseDate.push(changeToZeroMomentDate(order.caseNumberValidityFrom));
                }

                if (order.caseNumberValidityTo) {
                    caseDate.push(changeToZeroMomentDate(order.caseNumberValidityTo));
                }
                if (caseDate.length) {
                    name.push(caseDate.join('_'));
                }

                if (order.location) {
                    name.push(order.location);
                }

                name = name.join('/');
                order.name = name;

                // the saga reports its own failures; keep going so one bad order does not
                // stop the remaining ones from being created
                await asyncPersistOrder(
                    { ...data, ...order },
                    { orderDoc: props.orderDoc, files: props.files },
                    dispatch,
                ).catch(() => undefined);
            } else {
                //toast.error('Incorrect date!');
                throw new SubmissionError({
                    caseNumberValidityTo: 'Incorrect date!',
                    caseNumberValidityFrom: 'Incorrect date!',
                    _error: 'Incorrect date!',
                });
            }
        }
    },
    onSubmitSuccess(result: any, dispatch: Dispatch<any>, props: DecoratedFormProps<OrderFormData, OrderFormProps>) {},

    onSubmitFail(errors: { _error: string }) {
        if (errors?._error) {
            toast.error(errors._error);
        } else if (errors) {
            toast.error('Fill in the required fields.');
        }
    },
})(OrderForm);
